import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg, fmtRp, fmtNum } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const QUICK = ["Salah input", "Stok rusak/busuk", "Duplikat", "Lainnya"];

export function DeleteBatchDialog({ item, onClose, onDeleted }) {
  const [quick, setQuick] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setQuick(""); setNote(""); }, [item]);
  if (!item) return null;
  const reason = [quick && quick !== "Lainnya" ? quick : "", note.trim()].filter(Boolean).join(" — ");
  const valid = reason.length >= 5;
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.delete(`/inventory/${item.id}`, { data: { reason } });
      toast.success(`Batch ${item.batch_code} dihapus`, { action: { label: "Lihat Riwayat Hapus", onClick: () => onDeleted("deleted") }, duration: 8000 });
      onDeleted(); onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="delete-batch-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-rose-700"><Trash2 className="h-5 w-5" /> Hapus Batch</DialogTitle>
          <DialogDescription>Batch dipindahkan ke Riwayat Hapus dan masih bisa dipulihkan. Alasan wajib diisi.</DialogDescription>
        </DialogHeader>
        <div className="rounded-xl border border-rose-100 bg-rose-50/60 p-3 text-sm" data-testid="delete-batch-summary">
          <div className="font-mono font-bold text-sky-800">{item.batch_code}</div>
          <div className="font-semibold text-slate-800">{item.species_name} <span className="font-normal text-slate-600">{item.size}</span></div>
          <div className="mt-1 flex justify-between text-slate-600"><span>Sisa stok</span><b className="font-mono text-slate-900">{fmtNum(item.quantity_mc)} {item.unit || "MC"}</b></div>
          <div className="flex justify-between text-slate-600"><span>Nilai persediaan</span><b className="font-mono text-slate-900">{fmtRp((item.unit_cost || 0) * item.quantity_mc)}</b></div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div className="flex flex-wrap gap-2">
            {QUICK.map((q) => <button key={q} type="button" onClick={() => setQuick(q)} className={`px-3 py-1 rounded-full text-xs font-semibold border transition-colors ${quick === q ? "bg-rose-600 text-white border-rose-600" : "border-rose-200 text-rose-700 hover:bg-rose-50"}`} data-testid={`quick-reason-${q.replace(/[^a-z]/gi, "").toLowerCase()}`}>{q}</button>)}
          </div>
          <div className="space-y-1.5">
            <Label>Alasan penghapusan <span className="text-rose-600">*</span></Label>
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Keterangan tambahan (min. 5 karakter total)" rows={3} data-testid="input-delete-reason" />
            <div className="text-xs text-slate-500">Akan dicatat: <span className="text-slate-700">{reason || "—"}</span></div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} className="rounded-full" data-testid="btn-delete-cancel">Batal</Button>
            <Button type="submit" disabled={!valid || saving} className="rounded-full bg-rose-600 hover:bg-rose-700" data-testid="btn-delete-confirm">{saving ? "Menghapus..." : "Hapus"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
